import React from 'react';
import P, { InferProps } from 'prop-types';
import { SxStyle } from '../../../types';
import Grid from '@mui/material/Grid';
import ImageField from './image-field';
import TextInput from './text-field';
import { useStringsContext } from '../../../contexts/strings';

const styles: SxStyle = {
  containerInfo: {
    maxWidth: '600px',
  },
};

function PromoFieldFlarie({
  setChange,
  setValidation,
  fields,
  isReadOnly,
  path,
}: InferProps<typeof PromoFieldFlarie.propTypes>) {
  const { strings } = useStringsContext();
  const [contentUrlField, , targetUrlField, , widthField, heightField] = fields;

  return (
    <Grid container spacing={4} alignItems="center">
      <Grid item>
        <ImageField
          field={contentUrlField}
          widthField={widthField}
          heightField={heightField}
          setChange={setChange}
          key={contentUrlField.id}
          isReadOnly={isReadOnly}
          path={path}
          compact
        />
      </Grid>
      <Grid container item xs sx={styles.containerInfo} direction={'column'} spacing={2}>
        <Grid item>
          <TextInput
            field={{
              ...targetUrlField,
              title: strings.fields.promoGameLink,
            }}
            setChange={setChange}
            setValidation={setValidation}
            key={targetUrlField.id}
            isReadOnly={isReadOnly}
            fullWidth
          />
        </Grid>
      </Grid>
    </Grid>
  );
}

PromoFieldFlarie.propTypes = {
  setChange: P.func.isRequired,
  setValidation: P.func.isRequired,
  isReadOnly: P.bool,
  fields: P.any.isRequired,
  key: P.string,
  path: P.string.isRequired,
};

export default PromoFieldFlarie;
